import(/* webpackMode: "eager", webpackExports: ["LandingPageContents"] */ "/vercel/path0/apps/web/src/app/_ui/landing-page-contents.tsx");
